import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { useAddLeasingProjectMutation, useDeleteLeasingProjectMutation, useEditLeasingProjectMutation } from "../../../../../redux/api/handBooksApi/leasingProjectApi";


const useLeasingProject = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addLeasingProject] = useAddLeasingProjectMutation();
    const [deleteLeasingProject] = useDeleteLeasingProjectMutation();
    const [editLeasingProject] = useEditLeasingProjectMutation();

    async function onAddLeasingProject(newLeasingProject: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await addLeasingProject(newLeasingProject).then((response: any) => {
                if (response.error !== undefined) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteLeasingProject(leasingProject: EntDirectoryInfoName) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteLeasingProject(leasingProject.id as number).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditLeasingProject(editedLeasingProject: EntDirectoryInfoName): Promise<boolean> {
        try {
            let status: boolean = false;
            await editLeasingProject(editedLeasingProject).then((response: any) => {
                if (response.error !== undefined && response.error.status === 400) {
                    throw new Error(response.error.data.message);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddLeasingProject, onDeleteLeasingProject, onEditLeasingProject }
}

export { useLeasingProject };
